import { render, staticRenderFns } from "./ProgramaGobierno.vue?vue&type=template&id=23193557&scoped=true&"
import script from "./ProgramaGobierno.vue?vue&type=script&lang=js&"
export * from "./ProgramaGobierno.vue?vue&type=script&lang=js&"
import style0 from "./ProgramaGobierno.vue?vue&type=style&index=0&id=23193557&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23193557",
  null
  
)

export default component.exports